import React from 'react';

import {
  CloseIcon,
  CmBox,
  CmButton,
  CmCard,
  CmFlex,
  CmFormErrorMessage,
  CmFormLabel,
  CmIconButton,
  CmLabelAndInput,
  CmLabelAndTextarea,
  CmSelectDigitsTime,
  CmStack,
  CmText,
} from '@/components/uiParts';
import {
  DayOfWeekPeriod,
  dayOfWeekToJa,
  HandleChangeTime,
  menuForm,
} from '@/pages/menu-managements/business-hours/service';
import { MenuFormError } from '@/pages/menu-managements/business-hours/validate';
import { MenuManagementCardWrapper } from '@/pages/menu-managements/components/Wrapper';

type Props = {
  titleJa: string;
  memo: string;
  error: MenuFormError;
  dayOfWeekPeriods: DayOfWeekPeriod[];
  handleAddMenuHour: (index: number) => void;
  handleDeleteTime: (argDayOfWeekIndex: number, argPeriodIndex: number) => void;
  handleChangeStartTimeHour: HandleChangeTime;
  handleChangeStartTimeMinutes: HandleChangeTime;
  handleChangeEndTimeHour: HandleChangeTime;
  handleChangeEndTimeMinutes: HandleChangeTime;
  handleInputTitleJa: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleInputMemo: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
};

export const MenuManagementBusinessHoursForm: React.FC<Props> = ({
  titleJa,
  memo,
  error,
  dayOfWeekPeriods,
  handleAddMenuHour,
  handleDeleteTime,
  handleChangeStartTimeHour,
  handleChangeStartTimeMinutes,
  handleChangeEndTimeHour,
  handleChangeEndTimeMinutes,
  handleInputTitleJa,
  handleInputMemo,
}): JSX.Element => {
  return (
    <MenuManagementCardWrapper>
      <CmStack spacing="20px">
        <CmLabelAndInput
          isRequired
          id={menuForm.titleJa.key}
          isInvalid={error.titleJa.isError}
          label={menuForm.titleJa.label}
          fontWeight="bold"
          value={titleJa}
          onChange={handleInputTitleJa}
        >
          <CmFormErrorMessage>{error.titleJa.message}</CmFormErrorMessage>
        </CmLabelAndInput>
        <CmLabelAndTextarea
          id={menuForm.memo.key}
          isInvalid={error.memo.isError}
          label={menuForm.memo.label}
          fontWeight="bold"
          error={<CmFormErrorMessage>{error.memo.message}</CmFormErrorMessage>}
          value={memo}
          onChange={handleInputMemo}
        />
        <CmBox>
          <CmFormLabel isRequired fontWeight="bold">
            メニュー提供時間
          </CmFormLabel>
          <CmStack spacing="15px">
            {dayOfWeekPeriods.map((dayOfWeek, dayOfWeekIndex) => (
              <CmFlex key={dayOfWeek.day_of_week}>
                <CmCard
                  flexDirection="row"
                  alignItems="center"
                  justifyContent="center"
                  fontWeight="bold"
                  padding="5px"
                  width="200px"
                >
                  {dayOfWeekToJa[dayOfWeek.day_of_week]}
                </CmCard>

                <CmBox ml="10px" width="full">
                  {dayOfWeek.periods.map((period, periodIndex) => (
                    <CmCard
                      key={dayOfWeek.day_of_week + periodIndex}
                      padding={2}
                      mt={periodIndex > 0 ? '10px' : '0'}
                    >
                      <CmFlex
                        justifyContent="space-between"
                        alignItems="center"
                      >
                        <CmBox width="full">
                          <CmFlex
                            alignItems="center"
                            justifyContent="center"
                            width="full"
                          >
                            <CmSelectDigitsTime
                              date={period.start_time}
                              handleChangeHour={(hour) =>
                                handleChangeStartTimeHour(
                                  hour,
                                  dayOfWeekIndex,
                                  periodIndex
                                )
                              }
                              handleChangeMinutes={(minutes) =>
                                handleChangeStartTimeMinutes(
                                  minutes,
                                  dayOfWeekIndex,
                                  periodIndex
                                )
                              }
                            />
                            <CmText textAlign="center" mx="20px">
                              〜
                            </CmText>
                            <CmSelectDigitsTime
                              date={period.end_time}
                              handleChangeHour={(hour) =>
                                handleChangeEndTimeHour(
                                  hour,
                                  dayOfWeekIndex,
                                  periodIndex
                                )
                              }
                              handleChangeMinutes={(minutes) =>
                                handleChangeEndTimeMinutes(
                                  minutes,
                                  dayOfWeekIndex,
                                  periodIndex
                                )
                              }
                            />
                          </CmFlex>
                        </CmBox>
                        <CmIconButton
                          aria-label="Checked Notification"
                          icon={<CloseIcon />}
                          bg="white"
                          onClick={() =>
                            handleDeleteTime(dayOfWeekIndex, periodIndex)
                          }
                        />
                      </CmFlex>
                    </CmCard>
                  ))}
                  {/*
                   // @ts-ignore TS2590 */}
                  <CmButton
                    mt={dayOfWeek.periods.length > 0 ? '10px' : '0'}
                    width="full"
                    padding="20px"
                    onClick={() => handleAddMenuHour(dayOfWeekIndex)}
                  >
                    {dayOfWeekToJa[dayOfWeek.day_of_week]}
                    のメニュー提供時間を追加
                  </CmButton>
                </CmBox>
              </CmFlex>
            ))}
          </CmStack>
        </CmBox>
      </CmStack>
    </MenuManagementCardWrapper>
  );
};
